const arrToObj = arr =>
  arr.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.id]: curr
    }),
    {}
  );

export default arrToObj;
